export default [
  {
    path: '/admin/team/create',
    component: () =>
      import(
        '@/shared-modules/modules/admin/admin-entity-create/pages/admin.entity.create.layout.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import('@/shared-modules/modules/admin/admin-entity-create/pages/admin.team.create.vue')
      }
    ]
  },
  {
    path: '/admin/company/create',
    component: () =>
      import(
        '@/shared-modules/modules/admin/admin-entity-create/pages/admin.entity.create.layout.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/shared-modules/modules/admin/admin-entity-create/pages/admin.company.create.vue'
          )
      }
    ]
  }
];
